import React from 'react';
import { AlertFullSpan } from '@storebrand-digital/pretzel';
import { getText } from '@storebrand-digital/fms-translations';

function DocumentAlert() {
  const toggleShowAlert =
    getText('dashboard.alert.notificationLink.toggleShow') === '1';
  return (
    toggleShowAlert && (
      <AlertFullSpan
        variant="info"
        heading={`${getText('dashboard.alert.title')}`}
      >
        <p>
          {getText('dashboard.alert.description')}{' '}
          <a href={getText('dashboard.alert.notificationLink')}>
            {getText('dashboard.alert.notificationTitle')}
          </a>
        </p>
      </AlertFullSpan>
    )
  );
}

export default DocumentAlert;
